import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { OMNI_CONFIG, OmniConfig } from '@cigna/omni/shared';

@Pipe({
  name: 'cdnPrefix',
})
export class CdnPrefixPipe implements PipeTransform {
  constructor(@Inject(OMNI_CONFIG) private _config: OmniConfig) {}

  transform(path: string): string {
    return Location.joinWithSlash(this._config.omni.sonicNotification, path);
  }
}
